import { render, staticRenderFns } from "./SPRSimpleTextArea.vue?vue&type=template&id=0b208b6b&scoped=true"
import script from "./SPRSimpleTextArea.vue?vue&type=script&lang=js"
export * from "./SPRSimpleTextArea.vue?vue&type=script&lang=js"
import style0 from "./SPRSimpleTextArea.vue?vue&type=style&index=0&id=0b208b6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b208b6b",
  null
  
)

export default component.exports